import { Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-request-history',
  templateUrl: './request-history.component.html',
  standalone: false,
})
export class RequestHistoryComponent implements OnDestroy {
  constructor() {}

  ngOnDestroy() {
    sessionStorage.removeItem('savedFilters');
  }
}
